enum AbsenceBlockTabEnum {
    ABSENCES = 'ABSENCES',
    PROPOSALS = 'PROPOSALS',
    MY_PROPOSALS = 'MY_PROPOSALS',
    ACTIONS_HISTORY = "ACTIONS_HISTORY"
}

export default AbsenceBlockTabEnum;
